'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Styles = require('./PlanScorecardNameHeader.css');

var PlanScorecardNameHeader = (_dec = (0, _reactCssModules2.default)(Styles, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardNameHeader, _Component);

  function PlanScorecardNameHeader(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardNameHeader);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardNameHeader.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardNameHeader)).call(this, props));
  }

  (0, _createClass3.default)(PlanScorecardNameHeader, [{
    key: 'render',
    value: function render() {
      if (!this.props.planData) {
        return null;
      }
      var planData = this.props.planData;


      var hasPrimaryPlanLogo = false;
      var primaryPlanLogo = null;
      try {
        primaryPlanLogo = require('../../../static/images/plans/' + planData.path + '.png');
        hasPrimaryPlanLogo = true;
      } catch (e) {
        console.log('');
      }

      // let hasSecondaryPlanLogos = false
      // const secondaryPlanLogos = []
      // if (planData.secondary_plan_logos && planData.secondary_plan_logos.length>0) {
      //   for (let i=0; i<planData.secondary_plan_logos.length; i++){
      //     try {
      //       const thisSecondaryLogo = require('../../../static/images/plans/'+planData.secondary_plan_logos[i][0]+'.png')
      //       secondaryPlanLogos.push([thisSecondaryLogo, planData.secondary_plan_logos[i][1]])
      //       hasSecondaryPlanLogos = true
      //     }
      //     catch (e) {
      //       console.log('')
      //     }
      //   }
      // }

      var hasDefaultFundManagerLogo = false;
      var defaultFundManagerLogo = null;
      try {
        defaultFundManagerLogo = require('../../../static/images/fam/' + planData.default_fund_manager_path + '.png');
        hasDefaultFundManagerLogo = true;
      } catch (e) {
        console.log('');
      }

      var defaultFundSeriesFund = _config2.default.planOptionsSource[planData.rated_as_option[0][0]];
      var sStrategy = _format2.default.sanitize(defaultFundSeriesFund.strategy_name);
      var defaultFundSeriesUrl = _config2.default.routes.targetDateFunds + '/' + sStrategy;

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'name-flex' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { styleName: 'name-label-logo' },
            hasPrimaryPlanLogo ? _react2.default.createElement('img', {
              styleName: 'name-logo',
              src: primaryPlanLogo,
              alt: planData.short_name
            }) : null
          ),
          _react2.default.createElement(
            'h2',
            { styleName: 'name' },
            planData.primary_plan_name
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          hasDefaultFundManagerLogo ? _react2.default.createElement(
            'div',
            { styleName: 'plan-details-lede-img-wrap' },
            _react2.default.createElement(
              _components.Link,
              {
                to: defaultFundSeriesUrl,
                title: sStrategy
              },
              _react2.default.createElement('img', {
                src: defaultFundManagerLogo,
                alt: 'Default fund option managed by ' + planData.default_fund_manager,
                styleName: 'plan-details-lede-img'
              })
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { styleName: 'name-label' },
            _react2.default.createElement(
              'b',
              null,
              'Target date option'
            ),
            ' ',
            planData.default_fund_name
          ),
          planData.plan_names.length > 1 ? _react2.default.createElement(
            'div',
            { styleName: 'other-plan-names-label' },
            _react2.default.createElement(
              'b',
              null,
              'Other plan names'
            ),
            ' ',
            planData.plan_names.map(function (e, i) {
              return _react2.default.createElement(
                'span',
                { key: 'plannames-' + i },
                e,
                i < planData.plan_names.length - 1 ? ', ' : ''
              );
            })
          ) : null,
          _react2.default.createElement(
            'div',
            { styleName: 'name-label' },
            _react2.default.createElement(
              'b',
              null,
              'Plan data'
            ),
            ' ',
            planData.year,
            planData.filing_received ? _react2.default.createElement(
              'span',
              null,
              '\xA0(Filed ',
              planData.filing_received,
              ')'
            ) : null
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'name-label' },
            _react2.default.createElement(
              'b',
              null,
              'Fund data'
            ),
            ' ',
            _config2.default.versionDate
          )
        )
      );
    }
  }]);
  return PlanScorecardNameHeader;
}(_react.Component), _class2.propTypes = {
  planData: _react.PropTypes.object
}, _temp)) || _class);
exports.default = PlanScorecardNameHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardNameHeader/PlanScorecardNameHeader.js
// module id = 1422
// module chunks = 0